/* VR-Asset_CartTrust_2026-07-23-004
 * Lock icon on the cart drawer checkout button + trust row underneath.
 * Injected with JS so the theme's own cart-drawer template stays untouched —
 * if this ever fails, the cart keeps working exactly as before.
 *
 * ===========================================================================
 * EDIT ME — every claim below must match reality.
 *
 *   RATING  : cross-check against the shop average in the Judge.me dashboard.
 *   RETURNS : must match the published refund policy. Currently 30 days.
 *   FITMENT : describes the help offered, not a legal guarantee.
 *
 *   rating.value  = how far the stars are filled (4.5 = four and a half)
 *   rating.line1  = the number shown as text
 *   Keep those two in step with each other.
 * ===========================================================================
 */
(function () {
  var CONFIG = {
    buttonLabel: 'Checkout securely',

    rating: {
      value: 4.5,
      line1: '4.8 stars',
      line2: '25 reviews'
    },

    items: [
      { icon: 'return', text: '30-day<br>easy returns' },
      { icon: 'shield', text: 'Fitment check<br>for your bike' }
    ]
  };

  var STAR_PATH = 'M12 3.2l2.7 5.5 6 .9-4.35 4.24 1.03 6-5.38-2.83-5.38 2.83 1.03-6L3.3 9.6l6-.9z';

  var ICONS = {
    lock: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="5" y="10.5" width="14" height="10" rx="2"/><path d="M8.5 10.5V7.8a3.5 3.5 0 0 1 7 0v2.7"/></svg>',
    return: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9.5 6.5L5.5 10.5l4 4"/><path d="M5.5 10.5h8.25a4.75 4.75 0 0 1 0 9.5H10"/></svg>',
    shield: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21.2s7.2-3.6 7.2-9V5.4L12 2.8 4.8 5.4v6.8c0 5.4 7.2 9 7.2 9z"/><path d="M9.1 11.9l2.1 2.1 3.9-3.9"/></svg>',
    truck: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M2 6h11v10H2z"/><path d="M13 9h4l3 3v4h-7z"/><circle cx="6" cy="18" r="2"/><circle cx="17" cy="18" r="2"/></svg>',
    chat: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.5 11.5a7.9 7.9 0 0 1-8.5 7.9 9.3 9.3 0 0 1-3.9-.9L3.5 20l1.1-4.1a7.7 7.7 0 0 1-1.1-4.4 7.9 7.9 0 0 1 8.5-7.9 7.9 7.9 0 0 1 8.5 7.9z"/></svg>'
  };

  function starRow() {
    var one = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="' + STAR_PATH + '" fill="currentColor" stroke="none"/></svg>';
    var five = one + one + one + one + one;
    var value = Math.max(0, Math.min(5, Number(CONFIG.rating.value) || 0));
    var pct = (value / 5) * 100;
    return (
      '<span class="vr-stars" role="img" aria-label="' + value + ' out of 5 stars">' +
        '<span class="vr-stars__base">' + five + '</span>' +
        '<span class="vr-stars__fill" style="width:' + pct + '%">' + five + '</span>' +
      '</span>'
    );
  }

  var STYLE_ID = 'vr-cart-trust-style';

  function injectStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var css = [
      '.vr-cart-trust{display:grid;grid-template-columns:repeat(3,1fr);gap:4px;margin:18px 0 6px;padding-top:16px;border-top:1px solid #E5E7EB;}',
      '.vr-cart-trust__item{display:flex;flex-direction:column;align-items:center;justify-content:flex-start;gap:8px;text-align:center;padding:0 4px;}',
      '.vr-cart-trust__item > svg{width:20px;height:20px;fill:none;stroke:currentColor;stroke-width:1.6;stroke-linecap:round;stroke-linejoin:round;color:#0B0D10;flex:0 0 auto;}',
      '.vr-cart-trust__item span.vr-cart-trust__text{display:block;font-size:11px;line-height:1.4;color:#667085;font-family:var(--font-body-family);letter-spacing:0;text-transform:none;}',
      '.vr-stars{position:relative;display:inline-block;line-height:0;height:14px;flex:0 0 auto;}',
      '.vr-stars__base,.vr-stars__fill{display:block;white-space:nowrap;line-height:0;}',
      '.vr-stars__base{color:#D8DBE0;}',
      '.vr-stars__fill{position:absolute;top:0;left:0;overflow:hidden;color:#0B0D10;}',
      '.vr-stars svg{width:14px;height:14px;display:inline-block;vertical-align:top;}',
      '.cart__submit .vr-lock{display:inline-flex;align-items:center;justify-content:center;margin-right:10px;}',
      '.cart__submit .vr-lock svg{width:16px;height:16px;fill:none;stroke:currentColor;stroke-width:1.8;stroke-linecap:round;stroke-linejoin:round;}',
      '.cart__submit{display:flex !important;align-items:center;justify-content:center;}',
      '@media (max-width:380px){.vr-cart-trust__item span.vr-cart-trust__text{font-size:10px;}.vr-cart-trust__item > svg{width:18px;height:18px;}.vr-stars svg{width:12px;height:12px;}.vr-stars{height:12px;}}'
    ].join('');
    var el = document.createElement('style');
    el.id = STYLE_ID;
    el.textContent = css;
    document.head.appendChild(el);
  }

  function decorateButton(btn) {
    if (!btn || btn.querySelector('.vr-lock')) return;
    var label = (CONFIG.buttonLabel || btn.textContent || '').trim();
    btn.innerHTML = '<span class="vr-lock">' + ICONS.lock + '</span><span>' + label + '</span>';
  }

  function cell(inner, text) {
    var el = document.createElement('div');
    el.className = 'vr-cart-trust__item';
    el.innerHTML = inner + '<span class="vr-cart-trust__text">' + text + '</span>';
    return el;
  }

  function buildTrustRow() {
    var wrap = document.createElement('div');
    wrap.className = 'vr-cart-trust';

    if (CONFIG.rating) {
      wrap.appendChild(cell(starRow(), CONFIG.rating.line1 + '<br>' + CONFIG.rating.line2));
    }

    for (var i = 0; i < CONFIG.items.length; i++) {
      var item = CONFIG.items[i];
      wrap.appendChild(cell(ICONS[item.icon] || '', item.text));
    }
    return wrap;
  }

  function render() {
    injectStyle();
    var ctas = document.querySelector('#CartDrawer .cart__ctas');
    if (!ctas) return;
    decorateButton(ctas.querySelector('.cart__submit'));
    if (!ctas.querySelector('.vr-cart-trust')) {
      ctas.appendChild(buildTrustRow());
    }
  }

  function start() {
    render();
    var drawer = document.getElementById('CartDrawer');
    if (drawer && window.MutationObserver) {
      var pending = false;
      new MutationObserver(function () {
        if (pending) return;
        pending = true;
        window.requestAnimationFrame(function () {
          pending = false;
          render();
        });
      }).observe(drawer, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  setTimeout(render, 1500);
})();


/* ---------------------------------------------------------------
   Checkout button loading state (2026-08-05)

   Clicking "Checkout securely" navigates away, and the delay read as a
   dead click. On click we append a <span class="vr-co-spin"> and set
   .vr-co-loading; assets/vr-overrides.css styles and animates it and
   hides the button's other children.

   The listener is delegated on document, so it survives the drawer being
   re-rendered (the theme and vr-atc's refreshAndOpen both replace
   #CartDrawer's innerHTML). Capture phase so it runs before the theme's
   own submit handling.

   A real element is used rather than ::after because vr-overrides.css
   disables pseudo-elements on this button.
   --------------------------------------------------------------- */
(function () {
  var LOADING = 'vr-co-loading';
  var SPIN = 'vr-co-spin';
  var SEL = '#CartDrawer .cart__submit, .cart__ctas .cart__submit';

  function clear(btn) {
    if (!btn) return;
    btn.classList.remove(LOADING);
    btn.removeAttribute('aria-busy');
    var s = btn.querySelector('.' + SPIN);
    if (s && s.parentNode) s.parentNode.removeChild(s);
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var btn = e.target.closest(SEL);
    if (!btn || btn.disabled) return;
    if (btn.classList.contains(LOADING)) return;

    var spin = document.createElement('span');
    spin.className = SPIN;
    spin.setAttribute('aria-hidden', 'true');
    btn.appendChild(spin);
    btn.classList.add(LOADING);
    btn.setAttribute('aria-busy', 'true');

    /* Release if navigation never happens — a validation error, an offline
       device or a blocked redirect must not leave the button stuck. */
    setTimeout(function () { clear(btn); }, 12000);
  }, true);

  /* Back button restores from bfcache with the old DOM: clear any spinner
     that was left mid-navigation. */
  window.addEventListener('pageshow', function () {
    var stuck = document.querySelectorAll('.cart__submit.' + LOADING);
    for (var i = 0; i < stuck.length; i++) clear(stuck[i]);
  });
})();
